"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAdminSectionSuccess = exports.saveSectionFailure = exports.saveSectionSuccess = exports.deleteAdminProgramSuccess = exports.createProgramSuccess = exports.listProgramsRequest = exports.processQuestionSuccess = void 0;
const effects_1 = require("redux-saga/effects");
const toast_1 = require("@/components/toast");
const constants_1 = __importStar(require("@/constants"));
const history_1 = __importDefault(require("@/helpers/history"));
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
function* processQuestionSuccess() {
    yield effects_1.put(redux_1.ActionCreators.stepLayout.processQuestionsFinish.dispatch());
}
exports.processQuestionSuccess = processQuestionSuccess;
function* listProgramsRequest({ payload }) {
    yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.listProgramsPayload(payload)));
}
exports.listProgramsRequest = listProgramsRequest;
function* createProgramSuccess({ payload }) {
    yield effects_1.call(toast_1.showToast, '', constants_1.default.managePrograms.detail.programSuccessfullyCreated);
    yield effects_1.call(history_1.default.push, constants_1.Routes.ManageProgramsDetail.replace(':programId', payload.data.id));
}
exports.createProgramSuccess = createProgramSuccess;
function* deleteAdminProgramSuccess() {
    yield effects_1.call(toast_1.showToast, '', constants_1.default.managePrograms.detail.programSuccessfullyDeleted);
    yield effects_1.call(history_1.default.push, constants_1.Routes.ManagePrograms);
}
exports.deleteAdminProgramSuccess = deleteAdminProgramSuccess;
function* saveSectionSuccess({ payload }) {
    yield effects_1.call(toast_1.showToast, '', constants_1.default.managePrograms.detail.sectionSuccessfullySaved(payload.data.name));
}
exports.saveSectionSuccess = saveSectionSuccess;
function* saveSectionFailure(action) {
    const { statusCode } = action === null || action === void 0 ? void 0 : action.payload;
    yield effects_1.call(toast_1.showToast, '', `Error ${statusCode}`, constants_1.default.general.thereWasAnError);
}
exports.saveSectionFailure = saveSectionFailure;
function* deleteAdminSectionSuccess() {
    yield effects_1.call(toast_1.showToast, '', constants_1.default.managePrograms.detail.sectionSuccessfullyDeleted);
}
exports.deleteAdminSectionSuccess = deleteAdminSectionSuccess;
